import * as React from 'react';
import { clsx } from 'clsx';

type Props = Readonly<React.ComponentPropsWithoutRef<"i"> & {
	icon?: string
}>

function IconFontAwesome({icon = '', className = '',  ...otherProps}: Props) {
	return <i className={clsx("text-admin-input-icon icon-before fa-icon", className, icon)} {...otherProps}/>
}

export default IconFontAwesome;
